module.exports = __webpack_public_path__ + "img/test4.a0af36a4.png";